import { memo } from 'react';
import { useSelector } from 'react-redux';

import { PublicAnnotationComment } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/AnnotationAvatarContainer/components/PublicAnnotationComment';
import { PublicAnnotationsAvatars } from '~/components/AnnotationsV2/AnnotationsAvatarsContainer/components/PublicAnnotationsAvatars';
import { PublicFloatingCommentForm } from '~/components/AnnotationsV2/shared/PublicFloatingCommentForm';
import { usePublicPermissions } from '~/components/PublicPermissionsProvider';
import { usePublicVideoVisualizerClipMarkers } from '~/components/v2/components/asset-modal/visualizer/video/hooks/usePublicVideoVisualizerClipMarkers';
import { VideoVisualizer } from '~/components/v2/components/asset-modal/visualizer/video/VideoVisualizer';
import { centralizedClipSelector } from '~/store/centralizedClip/selectors';
import { canEditAssetDiscussions } from '~/utils/permissions/assetPermissions';

export const PublicVideoVisualizer = memo(() => {
  const clip = useSelector(centralizedClipSelector);
  const { permissions } = usePublicPermissions();
  const { markers } = usePublicVideoVisualizerClipMarkers();

  const canEditDiscussions = canEditAssetDiscussions(permissions);

  return (
    <VideoVisualizer
      AnnotationsAvatars={PublicAnnotationsAvatars}
      AnnotationComment={PublicAnnotationComment}
      FloatingCommentForm={PublicFloatingCommentForm}
      canEditDiscussions={canEditDiscussions}
      clip={clip}
      markers={markers}
    />
  );
});

PublicVideoVisualizer.displayName = 'PublicVideoVisualizer';
